import './Address.scss';
import Component from './Address.js';
export default Component;
